import './ListStates.css';
import React from 'react';
import BrandIcon from './BrandIcon';

/** 空态：居中莲花 + 引导文案 +（可选）行动按钮 */
export const EmptyState = ({ message, actionLabel, onAction }) => (
  <div className="list-empty">
    <BrandIcon size={56} className="list-empty-icon" />
    <p className="list-empty-text">{message}</p>
    {actionLabel && (
      <button className="btn btn-primary" onClick={onAction}>{actionLabel}</button>
    )}
  </div>
);

/** 骨架卡网格：加载态占位 */
export const SkeletonGrid = ({ count = 8, className = 'records-grid' }) => (
  <div className={className}>
    {Array.from({ length: count }).map((_, i) => (
      <div className="skeleton-card" key={i}>
        <div className="sk-line sk-title" />
        <div className="sk-chart" />
        <div className="sk-line sk-date" />
      </div>
    ))}
  </div>
);
